import React, {PropsWithChildren} from "react"

import * as styles from './styles.module.scss';
import cls from "classnames"
import {PricingRowsTable, PricingRowsTableProps} from "src/components/organisms/PlansTable/pricing";

type Cell = {
    type: string
    text: React.ReactNode | string
}

export type TableData = {
    thead: Cell[][]
    tbody: Cell[][]
}

export type PlansTableTheme = "green" | "pink"

export type PlansTableProps = {
    data: TableData
    pricingProps: PricingRowsTableProps
    className?: string
    theme?: PlansTableTheme
    childrenClassNames: {

    }
}

export const PlansTable = (props: PlansTableProps) => {

    const {data, pricingProps, className, childrenClassNames, theme} = props

    return (
        <div className={cls(styles.tableWrapper, "bs-flex-container l", className)}>

            <table className={styles.table}>
                <thead className={styles.thead}>
                {
                    data.thead.map((row) => {
                        return <tr className={styles.tr}>
                            {row.map((cell)=> {
                                    return <th className={cls(styles.th, styles["theme" + theme?.slice(0,1).toUpperCase() + theme?.slice(1)])}>{cell.text}</th>
                                })}
                        </tr>
                    })
                }
                </thead>
                <tbody className={styles.tbody}>
                {
                    data.tbody.map((row) => {
                        return <tr className={cls(styles.tr, row[0]?.type == "group-heading" ? styles.groupTr : "")}>
                            {row.map((cell)=> {
                                switch (cell.type) {
                                    case "spacer": return <td className={styles.spacer}>{cell.text}</td>
                                    case "group-heading": return <td className={styles.groupHeading}>{cell.text}</td>
                                    case "heading": return <td className={cls(styles.heading)}>{cell.text}</td>
                                    default: return <td className={styles.td}>{cell.text}</td>
                                }
                            })}
                        </tr>
                    })
                }
                <PricingRowsTable theme={theme} {...pricingProps}/>
                </tbody>
            </table>

        </div>
    )
}
